import { render } from "./MessageMobile.vue?vue&type=template&id=d4412dca&scoped=true"
import script from "./MessageMobile.vue?vue&type=script&lang=js"
export * from "./MessageMobile.vue?vue&type=script&lang=js"

import "./MessageMobile.vue?vue&type=style&index=0&id=d4412dca&scoped=true&lang=css"
import "@/styles_mobile/header.css?vue&type=style&index=1&id=d4412dca&scoped=true&lang=css&external"
import "@/styles_mobile/common.css?vue&type=style&index=2&id=d4412dca&scoped=true&lang=css&external"
import "@/styles_mobile/swiper.min.css?vue&type=style&index=3&id=d4412dca&scoped=true&lang=css&external"
import "@/styles_mobile/subcommon.css?vue&type=style&index=4&id=d4412dca&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4412dca"]])

export default __exports__